// Auto-generated by scratchpad_split.mjs during the i18n module split.
const plural = (count, forms) => forms[count > 1 ? "other" : "one"];

export const CHROME = {
  fr: {
    "lang.switchLabel": "Choisir la langue",
    "brand.title": "Production SFCR",
    "brand.subtitle": "EAM · SFCR 2026",
    "nav.workspace": "Espace dossier",
    "nav.plan": "Plan",
    "nav.report": "Le rapport",
    "nav.audits": "Audits",
    "nav.timeline": "Piste d'audit",
    "action.reset": "Reset",
    "action.admin": "Admin",
    "toast.demoReset": "Démo réinitialisée",
    "login.title": "Connexion mock locale",
    "login.email": "Email",
    "login.password": "Mot de passe",
    "login.submit": "Se connecter",
    "toast.loginOk": "Connexion mock OK",
    "audits.crumb": "Le rapport › Audits",
    "audits.title": "Audits du rapport",
    "audits.lead": "Trois audits indépendants : cohérence des chiffres dans le rapport, conformité réglementaire article par article, cohérence inter-millésimes (N-1 actuel vs N publié l'année précédente).",
    "audits.export": "⇩ Exporter en Excel",
    "audits.kpi.total": "Total contrôles",
    "audits.kpi.ok": "OK",
    "audits.kpi.ko": "KO",
    "audits.kpi.na": "N/A",
    "audits.tab.figures": "▦ Cohérence chiffres (0)",
    "audits.tab.regulatory": (p) => `♡ Réglementaire (${p.count}) `,
    "audits.tab.koPill": (p) => `${p.count} KO`,
    "audits.tab.vintages": "⌁ Inter-millésimes (0)",
    "audits.th.reference": "Référence",
    "audits.th.block": "Bloc",
    "audits.th.item": "Item",
    "audits.th.analysis": "Analyse",
    "audits.th.comment": "Commentaire",
    "audits.note": "<strong>Audits temps réel :</strong> chaque ligne KO est cliquable et ouvre le bloc concerné dans le rapport. L'éditeur du bloc permet de corriger directement le contenu et relance automatiquement les audits.",
    "toast.auditExport": "Export Audits_SFCR_2026_EAM_2026-06-26.xls généré",
    "timeline.title": "Piste d'audit",
    "timeline.lead": "Chronologie consolidée des décisions, agents, escalades et validations.",
    "timeline.empty": "Aucun événement pour le moment.",
    "plan.crumb": "Production SFCR · Plan global",
    "plan.title": "Plan du rapport à valider",
    "plan.lead": "La démo démarre par l'architecte : arborescence, conflits, propositions de modification et typologies sont proposés avant toute production de contenu.",
    "plan.validate": "Valider le plan et démarrer la production",
    "plan.blockCount": "blocs détectés",
    "plan.typologyCount": "typologies",
    "plan.conflictCount": "conflits à arbitrer",
    "plan.acceptableCount": "modifications acceptables",
    "plan.treeTitle": "Arborescence proposée",
    "plan.conflictsTitle": "Conflits détectés",
    "plan.proposalsTitle": "Propositions de modification",
    "plan.acceptable": "Acceptable",
    "plan.notAcceptable": "Non acceptable",
    "toast.planValidated": "Plan validé, rapport initialisé vide",
    "planv2.title": "Plan du SFCR 2026 · EAM Groupe",
    "planv2.lead": "L'agent <strong>Architecte</strong> a analysé <strong>le SFCR de l'année précédente</strong> (exercice 2024-2025, 67 pages) et propose ci-dessous la structure du nouveau rapport. La quasi-totalité des sous-parties est reprise à l'identique. Les modifications détectées sont signalées et soumises à votre validation.",
    "planv2.stat.chapters": "Chapitres",
    "planv2.stat.subParts": "Sous-parties",
    "planv2.stat.reprisesN1": "Reprises N-1",
    "planv2.stat.modifications": "Modifications proposées",
    "planv2.warningNone": "Aucune",
    "planv2.sourcesTitle": "Base de connaissances",
    "planv2.sourcesLead": ({ count }) => count ? `${count} document(s) disponible(s). Importez-en d'autres avant de lancer la production.` : "Aucun document importé. Importez vos sources avant de lancer la production bloc par bloc.",
    "planv2.sourcesCta": "Importer des documents",
    "planv2.warningTitle": (p) => `${p.label} modification proposée par l'Architecte — ${p.pending ? "décision requise" : "décision traitée"}`,
    "planv2.warningLead": "Avant de valider le plan, traitez les changements signalés ci-dessous.",
    "planv2.structureTitle": "Structure proposée",
    "planv2.structureLead": "Plan repris du SFCR N-1 — chaque ligne indique sa correspondance dans le rapport précédent (page) et sa typologie.",
    "planv2.subPart": (p) => plural(p.count, { one: "sous-partie", other: "sous-parties" }),
    "planv2.decisionBar": (p) => `✓ ${p.pending} ${plural(p.pending, { one: "décision", other: "décisions" })} en attente`,
    "planv2.decisionBarLead": "Une fois le plan validé, vous accédez à la production des blocs.",
    "planv2.validateNext": "Valider le plan →",
    "planv2.footnote": "Le plan validé est figé pour ce millésime. Toute modification ultérieure nécessitera une nouvelle validation par le manager.",
    "planv2.modified": "Modifié",
    "planv2.repriseN1": "Reprise N-1",
    "planv2.accepted": "Acceptée",
    "planv2.keptN1": "Conservé N-1",
    "toast.modificationAccepted": "Modification acceptée",
    "toast.blockN1Kept": "Bloc N-1 conservé",
    "toast.pendingDecisionFirst": "Traitez la décision en attente avant de valider",
    "blockStatus.empty": "A produire",
    "blockStatus.running": "En production",
    "blockStatus.escalated": "Escalade",
    "blockStatus.produced": "A valider",
    "blockStatus.audit_ko": "Audit KO",
    "blockStatus.validated": "Valide",
    "sidebar.title": "Sommaire",
    "sidebar.count": (p) => `${p.count} blocs`,
    "block.toProduce": "Bloc à produire",
    "block.emptyHint": "Ouvrir le drawer pour lancer la chaîne d'agents ou escalader au responsable RACI.",
    "block.manualEdit": "Modification humaine",
    "drawer.close": "Fermer",
    "drawer.notAssigned": "Non assigné",
    "drawer.sourcesCount": (p) => `sources`,
    "drawer.tab.production": "Production N",
    "drawer.tab.previous": "Année N-1",
    "drawer.tab.sources": (p) => `Sources (${p.count})`,
    "drawer.tab.audit": (p) => `Piste (${p.count})`,
    "drawer.agentProgress": (p) => `Agent ${p.current}/${p.total} en cours`,
    "drawer.allAuditsOk": "✓ Tous les audits OK pour ce bloc",
    "drawer.tableTitle": "Tableau produit",
    "drawer.textTitle": "Texte produit",
    "action.edit": "Modifier",
    "action.finish": "Terminer",
    "action.save": "Enregistrer",
    "action.cancel": "Annuler",
    "emptyDrawer.title": "Bloc vide",
    "emptyDrawer.lead": "Choisis une action pour produire ce bloc: lancer la chaîne d'agents ou escalader vers le responsable RACI.",
    "emptyDrawer.noSources": "Aucune source liée à ce bloc.",
    "emptyDrawer.runChain": "Lancer la chaîne d'agents",
    "emptyDrawer.escalate": "Escalader au responsable",
    "escalation.notice": "Escalade ouverte avec le responsable RACI. La réponse validée sera utilisée directement comme texte du bloc.",
    "auditKo.title": (p) => `△ ${p.count} KO d'audit détecté sur ce bloc`,
    "auditKo.escalate": "Escalader au responsable",
    "auditKo.relaunch": "↻ Relancer l'audit",
    "chain.running": "Chaîne en cours",
    "chain.runningLead": "Les étapes adaptées au bloc se relaient pour produire le contenu.",
    "chain.compactLead": "Workflow adapté au bloc et à sa typologie.",
    "chain.workflow": "Workflow",
    "chain.summary": (p) =>
      `${p.agents} ${plural(p.agents, { one: "agent", other: "agents" })}${p.branches ? ` + ${p.branches} ${plural(p.branches, { one: "branche", other: "branches" })}` : ""}${p.humans ? ` + ${p.humans} ${plural(p.humans, { one: "validation", other: "validations" })}` : ""}`,
    "status.done": "Terminé",
    "status.running": "En cours",
    "status.queued": "En attente",
    "previous.title": "Année N-1",
    "previous.empty": "Aucun contenu N-1 disponible dans la capture.",
    "sources.citationsTitle": "Citations générées",
    "sources.chunks": (p) => `${p.count} chunks`,
    "audit.empty": "Aucune piste d'audit pour ce bloc.",
    "escalation.chatTitle": (p) => `Chat d'escalade · ${p.name}`,
    "escalation.defaultResponsible": "Responsable",
    "escalation.interlocutor": "Interlocuteur",
    "escalation.emptyChat": "Sélectionne un interlocuteur puis envoie la demande d'escalade.",
    "escalation.replyReady": "Réponse prête à utiliser",
    "escalation.useAsText": "Utiliser cette réponse comme texte",
    "escalation.send": "Envoyer la demande",
    "escalation.simulate": "Simuler la réponse contributeur",
    "escalation.regenerate": "Regénérer une réponse",
    "escalation.close": "Fermer l'escalade",
    "table.indicator": "Indicateur",
    "table.n1": "N-1",
    "table.n": "N",
    "table.variation": "Var.",
    "table.empty": "Aucun tableau produit.",
    "citation.legend.figure": "chiffre sourcé",
    "citation.legend.contributor": "contributeur",
    "citation.legend.kb": "extrait KB",
    "citation.legend.count": (p) => `${p.count} ${plural(p.count, { one: "citation", other: "citations" })} · clic sur les numéros dans le texte`,
    "citation.popover.kb": "SOURCE KB",
    "citation.popover.contributor": "CONTRIBUTEUR",
    "citation.popover.figure": "CHIFFRE SOURCÉ",
    "citation.popover.confidence": (p) => `confiance · ${p.value}`,
    "footer.runChain": "Lancer la chaîne",
    "footer.validateBlock": "Valider le bloc",
    "toast.blockAlreadyValidated": "Bloc déjà validé: réouverture nécessaire avant relance",
    "toast.escalationReplyUsed": "Réponse escaladée utilisée comme texte",
    "toast.blockValidated": "Bloc validé",
    "toast.auditRelaunched": "Audit relancé: OK",
    "toast.textSaved": "Texte enregistré",
    "toast.tableSaved": "Tableau enregistré",
    "admin.backToReport": "Retour au rapport",
    "admin.title": "Administration",
    "admin.nav.overview": "Vue d'ensemble",
    "admin.nav.typologies": "Typologies & workflows",
    "admin.nav.knowledgeBase": "Base de connaissances",
    "admin.nav.regulatory": "Référentiel réglementaire",
    "admin.nav.agents": "Agents IA",
    "admin.nav.raci": "RACI & équipes",
    "admin.resetDemo": "Réinitialiser la démo",
    "toast.addMock": "Ajout mock: formulaire prêt à brancher",
    "toast.kbUploading": ({ name }) => `Import de ${name}…`,
    "toast.sourcesSaved": ({ count, code }) => `${count} source(s) liée(s) au bloc ${code}.`,
    "toast.kbIndexed": ({ pages, chunks }) => `PDF importé : ${pages} pages, ${chunks} passages citables.`,
    "toast.kbNeedsOcr": ({ pages }) => `PDF importé, mais ${pages} page(s) sans texte : OCR requis.`,
    "admin.overview.crumb": "Accueil > Administration",
    "admin.overview.title": "Vue d'ensemble",
    "admin.overview.subtitle": "Pilotage local de la démo SFCR.",
    "admin.overview.typologies": "typologies",
    "admin.overview.kbDocs": "documents KB",
    "admin.overview.articles": "articles",
    "admin.overview.agents": "agents IA",
    "admin.typologies.crumb": "Le rapport > Administration > Typologies & workflows",
    "admin.typologies.title": "Typologies de paragraphes",
    "admin.typologies.subtitle": "12 typologies industrialisées issues de l'analyse paragraphe par paragraphe d'un SFCR.",
    "admin.typologies.agents": "agents",
    "admin.typologies.srcObl": "src obl.",
    "admin.typologies.min": "min",
    "admin.typologies.escalationRate": "% escalades",
    "admin.kb.crumb": "Accueil > Administration > Base de connaissances",
    "admin.kb.title": "Base de connaissances",
    "admin.kb.subtitle": "Documents indexés et chunks sémantiques utilisés par les agents.",
    "admin.kb.indexedDocs": "Documents indexés",
    "admin.kb.chunks": "Chunks sémantiques",
    "admin.kb.categories": "Catégories",
    "admin.kb.overDraftLimit": "Trop volumineux pour la rédaction",
    "admin.kb.upload.dropzone": "Glissez un PDF ici",
    "sources.manage.open": "Gérer les sources",
    "sources.manage.title": ({ code }) => `Sources du bloc ${code}`,
    "sources.manage.subtitle": "Sélectionnez les documents que les agents pourront citer pour ce bloc.",
    "sources.manage.search": "Rechercher un document",
    "sources.manage.selected": ({ count }) => `${count} document(s) sélectionné(s)`,
    "sources.manage.noMatch": "Aucun document ne correspond",
    "sources.manage.empty": "Aucune source liée : la rédaction utilisera les documents par défaut de la typologie.",
    "admin.kb.upload.browse": "Parcourir",
    "admin.kb.upload.remove": "Retirer le fichier",
    "admin.kb.upload.notPdf": "Seuls les fichiers PDF sont acceptés.",
    "admin.kb.upload.tooLarge": ({ limit }) => `Fichier trop volumineux (maximum ${limit}).`,
    "admin.kb.upload.uploading": ({ percent }) => `Import ${percent} %`,
    "admin.kb.empty.title": "Aucun document",
    "admin.kb.empty.body": "Importez un PDF pour alimenter la base de connaissances.",
    "admin.kb.detail.pages": "Pages",
    "admin.kb.detail.passages": "Passages",
    "admin.kb.detail.characters": "Caractères",
    "admin.kb.detail.usedBy": "Blocs liés",
    "admin.kb.detail.usedByTitle": "Blocs utilisant ce document",
    "admin.kb.detail.usedByNone": "Aucun bloc n'utilise encore ce document comme source.",
    "admin.kb.detail.passagesTitle": "Passages citables",
    "admin.kb.detail.page": ({ page }) => `Page ${page}`,
    "admin.kb.detail.showMore": ({ remaining }) => `Afficher ${remaining} passage(s) de plus`,
    "admin.kb.detail.ocrTitle": "Pages sans couche texte",
    "admin.kb.detail.ocrBody": ({ pages }) => `Pages ${pages} : ce sont des scans. Elles ne fournissent aucun passage citable tant qu'un OCR n'a pas été exécuté.`,
    "admin.kb.detail.limitTitle": "Trop volumineux pour la rédaction",
    "admin.kb.detail.limitBody": "Le document dépasse la limite par source d'une requête de rédaction. Liez-le à un bloc dès maintenant : la sélection des passages pertinents sera faite par la recherche documentaire, qui reste à implémenter.",
    "admin.kb.detail.missing": "Document introuvable",
    "admin.kb.upload.file": "Fichier PDF",
    "admin.kb.upload.defaultOrigin": "Import manuel",
    "admin.kb.upload.submit": "Importer un PDF",
    "admin.kb.upload.hint": "Le texte est extrait page par page. Les pages scannées sont signalées : elles demandent un OCR avant de servir de source.",
    "admin.kb.th.document": "Document",
    "admin.kb.th.category": "Catégorie",
    "admin.kb.th.origin": "Origine",
    "admin.kb.th.chunks": "Chunks",
    "admin.kb.th.status": "Statut",
    "admin.kb.th.indexedAt": "Indexé le",
    "admin.regulatory.crumb": "Accueil > Administration > Référentiel réglementaire",
    "admin.regulatory.title": "Référentiel réglementaire",
    "admin.regulatory.subtitle": "15 articles du règlement délégué Solvabilité 2, utilisés par l'Auditeur Réglementaire.",
    "admin.regulatory.add": "+ Ajouter un article",
    "admin.regulatory.th.reference": "Référence",
    "admin.regulatory.th.title": "Titre / item",
    "admin.regulatory.th.reports": "Rapports concernés",
    "admin.regulatory.th.mapping": "Mapping chapitres",
    "admin.regulatory.th.status": "Statut",
    "admin.regulatory.soloReport": "SFCR solo",
    "admin.regulatory.applicable": "Applicable",
    "admin.regulatory.edit": "Éditer ›",
    "admin.agentsPage.crumb": "Accueil > Administration > Agents IA",
    "admin.agentsPage.title": "Agents IA spécialisés",
    "admin.agentsPage.subtitle": "10 agents configurés. Chaque agent a un rôle, un prompt template, un modèle et des sources rattachées.",
    "admin.agentsPage.kbCategory": "catégorie KB",
    "admin.agentsPage.calls": "Fait appel à",
    "admin.agentsPage.sources": "Sources accessibles",
    "admin.agentsPage.noDirectSource": "Aucune source directe",
    "admin.agentsPage.call.promptTemplate": "Prompt template",
    "admin.agentsPage.call.auditTrail": "Piste d'audit",
    "admin.agentsPage.call.knowledgeBase": "Base de connaissances",
    "admin.agentsPage.call.qrtReporting": "QRT / reporting",
    "admin.agentsPage.call.businessKb": "KB métier",
    "admin.agentsPage.call.raciContributors": "RACI contributeurs",
    "admin.agentsPage.call.publicResearch": "Recherche publique",
    "admin.agentsPage.call.macroData": "Données macro",
    "admin.agentsPage.call.regulatoryWatch": "Veille réglementaire",
    "admin.agentsPage.call.previousText": "Texte N-1",
    "admin.agentsPage.call.sfcrGuidelines": "Guidelines SFCR",
    "admin.agentsPage.call.regulatoryFramework": "Référentiel réglementaire",
    "admin.agentsPage.call.consistencyRules": "Règles de cohérence",
    "admin.agentsPage.call.raciMatrix": "Matrice RACI",
    "admin.agentsPage.call.escalationChat": "Chat d'escalade",
    "admin.agentsPage.call.globalPlan": "Plan global",
    "admin.agentsPage.call.n1Structure": "Structure N-1",
    "admin.agentsPage.doc.raciMatrix": "Matrice RACI",
    "admin.agentsPage.doc.contributorThreads": "Threads contributeurs",
    "admin.raci.crumb": "Accueil > Administration > RACI & équipes",
    "admin.raci.title": "Matrice RACI",
    "admin.raci.subtitle": "Qui contribue à quoi, par typologie de bloc. Cette matrice détermine les escalades automatiques par email.",
    "admin.raci.team": "Équipe",
    "admin.raci.matrix": "Matrice RACI par typologie",
    "admin.raci.th.typology": "Typologie de bloc",
    "admin.raci.th.responsible": "Responsible (R)",
    "admin.raci.th.accountable": "Accountable (A)",
    "admin.raci.th.consulted": "Consulted (C)",
    "admin.raci.th.informed": "Informed (I)",
    "admin.detail.notFound": "Élément introuvable",
    "admin.detail.title": (p) => `Administration > ${p.section}`,
    "admin.detail.subtitle": "Détail éditable sauvegardé localement.",
    "admin.detail.back": "Retour",
    "admin.detail.jsonTitle": "Configuration JSON",
    "toast.adminSaved": "Configuration enregistrée",
    "toast.adminInvalidJson": "JSON invalide",
  },
  en: {
    "lang.switchLabel": "Choose language",
    "brand.title": "SFCR Production",
    "brand.subtitle": "EAM · SFCR 2026",
    "nav.workspace": "Dossier workspace",
    "nav.plan": "Plan",
    "nav.report": "Report",
    "nav.audits": "Audits",
    "nav.timeline": "Audit trail",
    "action.reset": "Reset",
    "action.admin": "Admin",
    "toast.demoReset": "Demo reset",
    "login.title": "Local mock login",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "toast.loginOk": "Mock sign-in OK",
    "audits.crumb": "Report › Audits",
    "audits.title": "Report audits",
    "audits.lead": "Three independent audits: figure consistency across the report, article-by-article regulatory compliance, and cross-vintage consistency (current N-1 vs. N published the previous year).",
    "audits.export": "⇩ Export to Excel",
    "audits.kpi.total": "Total checks",
    "audits.kpi.ok": "OK",
    "audits.kpi.ko": "KO",
    "audits.kpi.na": "N/A",
    "audits.tab.figures": "▦ Figure consistency (0)",
    "audits.tab.regulatory": (p) => `♡ Regulatory (${p.count}) `,
    "audits.tab.koPill": (p) => `${p.count} KO`,
    "audits.tab.vintages": "⌁ Cross-vintage (0)",
    "audits.th.reference": "Reference",
    "audits.th.block": "Block",
    "audits.th.item": "Item",
    "audits.th.analysis": "Analysis",
    "audits.th.comment": "Comment",
    "audits.note": "<strong>Real-time audits:</strong> every KO row is clickable and opens the relevant block in the report. The block editor lets you fix the content directly and automatically reruns the audits.",
    "toast.auditExport": "Audits_SFCR_2026_EAM_2026-06-26.xls exported",
    "timeline.title": "Audit trail",
    "timeline.lead": "Consolidated timeline of decisions, agents, escalations and approvals.",
    "timeline.empty": "No event yet.",
    "plan.crumb": "SFCR Production · Global plan",
    "plan.title": "Report plan to approve",
    "plan.lead": "The demo starts with the Architect: outline, conflicts, change proposals and typologies are proposed before any content is produced.",
    "plan.validate": "Approve the plan and start production",
    "plan.blockCount": "blocks detected",
    "plan.typologyCount": "typologies",
    "plan.conflictCount": "conflicts to resolve",
    "plan.acceptableCount": "acceptable changes",
    "plan.treeTitle": "Proposed outline",
    "plan.conflictsTitle": "Detected conflicts",
    "plan.proposalsTitle": "Change proposals",
    "plan.acceptable": "Acceptable",
    "plan.notAcceptable": "Not acceptable",
    "toast.planValidated": "Plan approved, report initialized empty",
    "planv2.title": "SFCR 2026 plan · EAM Group",
    "planv2.lead": "The <strong>Architect</strong> agent analyzed <strong>last year's SFCR</strong> (2024-2025 fiscal year, 67 pages) and proposes the structure of the new report below. Almost all sub-sections are carried over unchanged. Detected changes are flagged and submitted for your approval.",
    "planv2.stat.chapters": "Chapters",
    "planv2.stat.subParts": "Sub-sections",
    "planv2.stat.reprisesN1": "Carried over from N-1",
    "planv2.stat.modifications": "Proposed changes",
    "planv2.warningNone": "None",
    "planv2.sourcesTitle": "Knowledge base",
    "planv2.sourcesLead": ({ count }) => count ? `${count} document(s) available. Import more before starting production.` : "No document imported yet. Import your sources before starting block-by-block production.",
    "planv2.sourcesCta": "Import documents",
    "planv2.warningTitle": (p) => `${p.label} change proposed by the Architect — ${p.pending ? "decision required" : "decision handled"}`,
    "planv2.warningLead": "Before approving the plan, review the flagged changes below.",
    "planv2.structureTitle": "Proposed structure",
    "planv2.structureLead": "Plan carried over from the N-1 SFCR — each row shows its match in the previous report (page) and its typology.",
    "planv2.subPart": (p) => plural(p.count, { one: "sub-section", other: "sub-sections" }),
    "planv2.decisionBar": (p) => `✓ ${p.pending} ${plural(p.pending, { one: "decision", other: "decisions" })} pending`,
    "planv2.decisionBarLead": "Once the plan is approved, you get access to block production.",
    "planv2.validateNext": "Approve the plan →",
    "planv2.footnote": "The approved plan is locked for this vintage. Any later change will require a new approval from the manager.",
    "planv2.modified": "Modified",
    "planv2.repriseN1": "Carried over from N-1",
    "planv2.accepted": "Accepted",
    "planv2.keptN1": "N-1 kept",
    "toast.modificationAccepted": "Change accepted",
    "toast.blockN1Kept": "N-1 block kept",
    "toast.pendingDecisionFirst": "Resolve the pending decision before approving",
    "blockStatus.empty": "To produce",
    "blockStatus.running": "In production",
    "blockStatus.escalated": "Escalated",
    "blockStatus.produced": "To approve",
    "blockStatus.audit_ko": "Audit KO",
    "blockStatus.validated": "Approved",
    "sidebar.title": "Contents",
    "sidebar.count": (p) => `${p.count} blocks`,
    "block.toProduce": "Block to produce",
    "block.emptyHint": "Open the drawer to start the agent chain or escalate to the RACI owner.",
    "block.manualEdit": "Human edit",
    "drawer.close": "Close",
    "drawer.notAssigned": "Unassigned",
    "drawer.sourcesCount": (p) => `sources`,
    "drawer.tab.production": "Production N",
    "drawer.tab.previous": "Year N-1",
    "drawer.tab.sources": (p) => `Sources (${p.count})`,
    "drawer.tab.audit": (p) => `Trail (${p.count})`,
    "drawer.agentProgress": (p) => `Agent ${p.current}/${p.total} running`,
    "drawer.allAuditsOk": "✓ All audits OK for this block",
    "drawer.tableTitle": "Produced table",
    "drawer.textTitle": "Produced text",
    "action.edit": "Edit",
    "action.finish": "Done",
    "action.save": "Save",
    "action.cancel": "Cancel",
    "emptyDrawer.title": "Empty block",
    "emptyDrawer.lead": "Choose an action to produce this block: start the agent chain or escalate to the RACI owner.",
    "emptyDrawer.noSources": "No source linked to this block.",
    "emptyDrawer.runChain": "Start the agent chain",
    "emptyDrawer.escalate": "Escalate to owner",
    "escalation.notice": "Escalation open with the RACI owner. The approved reply will be used directly as the block's text.",
    "auditKo.title": (p) => `△ ${p.count} audit KO detected on this block`,
    "auditKo.escalate": "Escalate to owner",
    "auditKo.relaunch": "↻ Rerun audit",
    "chain.running": "Chain running",
    "chain.runningLead": "The steps adapted to the block run one after another to produce the content.",
    "chain.compactLead": "Workflow adapted to the block and its typology.",
    "chain.workflow": "Workflow",
    "chain.summary": (p) =>
      `${p.agents} ${plural(p.agents, { one: "agent", other: "agents" })}${p.branches ? ` + ${p.branches} ${plural(p.branches, { one: "branch", other: "branches" })}` : ""}${p.humans ? ` + ${p.humans} ${plural(p.humans, { one: "approval", other: "approvals" })}` : ""}`,
    "status.done": "Done",
    "status.running": "Running",
    "status.queued": "Queued",
    "previous.title": "Year N-1",
    "previous.empty": "No N-1 content available in the capture.",
    "sources.citationsTitle": "Generated citations",
    "sources.chunks": (p) => `${p.count} chunks`,
    "audit.empty": "No audit trail for this block.",
    "escalation.chatTitle": (p) => `Escalation chat · ${p.name}`,
    "escalation.defaultResponsible": "Owner",
    "escalation.interlocutor": "Contact",
    "escalation.emptyChat": "Pick a contact then send the escalation request.",
    "escalation.replyReady": "Reply ready to use",
    "escalation.useAsText": "Use this reply as text",
    "escalation.send": "Send the request",
    "escalation.simulate": "Simulate contributor reply",
    "escalation.regenerate": "Regenerate a reply",
    "escalation.close": "Close escalation",
    "table.indicator": "Indicator",
    "table.n1": "N-1",
    "table.n": "N",
    "table.variation": "Var.",
    "table.empty": "No table produced.",
    "citation.legend.figure": "sourced figure",
    "citation.legend.contributor": "contributor",
    "citation.legend.kb": "KB excerpt",
    "citation.legend.count": (p) => `${p.count} ${plural(p.count, { one: "citation", other: "citations" })} · click the numbers in the text`,
    "citation.popover.kb": "KB SOURCE",
    "citation.popover.contributor": "CONTRIBUTOR",
    "citation.popover.figure": "SOURCED FIGURE",
    "citation.popover.confidence": (p) => `confidence · ${p.value}`,
    "footer.runChain": "Start the chain",
    "footer.validateBlock": "Approve the block",
    "toast.blockAlreadyValidated": "Block already approved: reopen it before rerunning",
    "toast.escalationReplyUsed": "Escalated reply used as text",
    "toast.blockValidated": "Block approved",
    "toast.auditRelaunched": "Audit rerun: OK",
    "toast.textSaved": "Text saved",
    "toast.tableSaved": "Table saved",
    "admin.backToReport": "Back to report",
    "admin.title": "Administration",
    "admin.nav.overview": "Overview",
    "admin.nav.typologies": "Typologies & workflows",
    "admin.nav.knowledgeBase": "Knowledge base",
    "admin.nav.regulatory": "Regulatory framework",
    "admin.nav.agents": "AI agents",
    "admin.nav.raci": "RACI & teams",
    "admin.resetDemo": "Reset the demo",
    "toast.addMock": "Mock add: form ready to wire up",
    "toast.kbUploading": ({ name }) => `Importing ${name}…`,
    "toast.sourcesSaved": ({ count, code }) => `${count} source(s) linked to block ${code}.`,
    "toast.kbIndexed": ({ pages, chunks }) => `PDF imported: ${pages} pages, ${chunks} citable passages.`,
    "toast.kbNeedsOcr": ({ pages }) => `PDF imported, but ${pages} page(s) have no text: OCR required.`,
    "admin.overview.crumb": "Home > Administration",
    "admin.overview.title": "Overview",
    "admin.overview.subtitle": "Local control of the SFCR demo.",
    "admin.overview.typologies": "typologies",
    "admin.overview.kbDocs": "KB documents",
    "admin.overview.articles": "articles",
    "admin.overview.agents": "AI agents",
    "admin.typologies.crumb": "Report > Administration > Typologies & workflows",
    "admin.typologies.title": "Paragraph typologies",
    "admin.typologies.subtitle": "12 industrialized typologies derived from a paragraph-by-paragraph analysis of an SFCR.",
    "admin.typologies.agents": "agents",
    "admin.typologies.srcObl": "req. sources",
    "admin.typologies.min": "min",
    "admin.typologies.escalationRate": "% escalations",
    "admin.kb.crumb": "Home > Administration > Knowledge base",
    "admin.kb.title": "Knowledge base",
    "admin.kb.subtitle": "Indexed documents and semantic chunks used by the agents.",
    "admin.kb.indexedDocs": "Indexed documents",
    "admin.kb.chunks": "Semantic chunks",
    "admin.kb.categories": "Categories",
    "admin.kb.overDraftLimit": "Too large for drafting",
    "admin.kb.upload.dropzone": "Drop a PDF here",
    "sources.manage.open": "Manage sources",
    "sources.manage.title": ({ code }) => `Sources for block ${code}`,
    "sources.manage.subtitle": "Pick the documents the agents may cite for this block.",
    "sources.manage.search": "Search a document",
    "sources.manage.selected": ({ count }) => `${count} document(s) selected`,
    "sources.manage.noMatch": "No document matches",
    "sources.manage.empty": "No source linked: drafting falls back to the typology's default documents.",
    "admin.kb.upload.browse": "Browse",
    "admin.kb.upload.remove": "Remove the file",
    "admin.kb.upload.notPdf": "Only PDF files are accepted.",
    "admin.kb.upload.tooLarge": ({ limit }) => `File too large (maximum ${limit}).`,
    "admin.kb.upload.uploading": ({ percent }) => `Uploading ${percent}%`,
    "admin.kb.empty.title": "No documents yet",
    "admin.kb.empty.body": "Import a PDF to populate the knowledge base.",
    "admin.kb.detail.pages": "Pages",
    "admin.kb.detail.passages": "Passages",
    "admin.kb.detail.characters": "Characters",
    "admin.kb.detail.usedBy": "Linked blocks",
    "admin.kb.detail.usedByTitle": "Blocks using this document",
    "admin.kb.detail.usedByNone": "No block uses this document as a source yet.",
    "admin.kb.detail.passagesTitle": "Citable passages",
    "admin.kb.detail.page": ({ page }) => `Page ${page}`,
    "admin.kb.detail.showMore": ({ remaining }) => `Show ${remaining} more passage(s)`,
    "admin.kb.detail.ocrTitle": "Pages without a text layer",
    "admin.kb.detail.ocrBody": ({ pages }) => `Pages ${pages} are scans. They contribute no citable passage until OCR has run.`,
    "admin.kb.detail.limitTitle": "Too large for drafting",
    "admin.kb.detail.limitBody": "The document exceeds the per-source limit of a drafting request. Link it to a block now: picking the relevant passages is what retrieval will do, and that is not implemented yet.",
    "admin.kb.detail.missing": "Document not found",
    "admin.kb.upload.file": "PDF file",
    "admin.kb.upload.defaultOrigin": "Manual import",
    "admin.kb.upload.submit": "Import a PDF",
    "admin.kb.upload.hint": "Text is extracted page by page. Scanned pages are reported: they need OCR before they can be used as a source.",
    "admin.kb.th.document": "Document",
    "admin.kb.th.category": "Category",
    "admin.kb.th.origin": "Origin",
    "admin.kb.th.chunks": "Chunks",
    "admin.kb.th.status": "Status",
    "admin.kb.th.indexedAt": "Indexed on",
    "admin.regulatory.crumb": "Home > Administration > Regulatory framework",
    "admin.regulatory.title": "Regulatory framework",
    "admin.regulatory.subtitle": "15 articles of the Solvency II delegated regulation, used by the Regulatory Auditor.",
    "admin.regulatory.add": "+ Add an article",
    "admin.regulatory.th.reference": "Reference",
    "admin.regulatory.th.title": "Title / item",
    "admin.regulatory.th.reports": "Reports concerned",
    "admin.regulatory.th.mapping": "Chapter mapping",
    "admin.regulatory.th.status": "Status",
    "admin.regulatory.soloReport": "Solo SFCR",
    "admin.regulatory.applicable": "Applicable",
    "admin.regulatory.edit": "Edit ›",
    "admin.agentsPage.crumb": "Home > Administration > AI agents",
    "admin.agentsPage.title": "Specialized AI agents",
    "admin.agentsPage.subtitle": "10 configured agents. Each agent has a role, a prompt template, a model and attached sources.",
    "admin.agentsPage.kbCategory": "KB category",
    "admin.agentsPage.calls": "Calls on",
    "admin.agentsPage.sources": "Accessible sources",
    "admin.agentsPage.noDirectSource": "No direct source",
    "admin.agentsPage.call.promptTemplate": "Prompt template",
    "admin.agentsPage.call.auditTrail": "Audit trail",
    "admin.agentsPage.call.knowledgeBase": "Knowledge base",
    "admin.agentsPage.call.qrtReporting": "QRT / reporting",
    "admin.agentsPage.call.businessKb": "Business KB",
    "admin.agentsPage.call.raciContributors": "RACI contributors",
    "admin.agentsPage.call.publicResearch": "Public research",
    "admin.agentsPage.call.macroData": "Macro data",
    "admin.agentsPage.call.regulatoryWatch": "Regulatory watch",
    "admin.agentsPage.call.previousText": "N-1 text",
    "admin.agentsPage.call.sfcrGuidelines": "SFCR guidelines",
    "admin.agentsPage.call.regulatoryFramework": "Regulatory framework",
    "admin.agentsPage.call.consistencyRules": "Consistency rules",
    "admin.agentsPage.call.raciMatrix": "RACI matrix",
    "admin.agentsPage.call.escalationChat": "Escalation chat",
    "admin.agentsPage.call.globalPlan": "Global plan",
    "admin.agentsPage.call.n1Structure": "N-1 structure",
    "admin.agentsPage.doc.raciMatrix": "RACI matrix",
    "admin.agentsPage.doc.contributorThreads": "Contributor threads",
    "admin.raci.crumb": "Home > Administration > RACI & teams",
    "admin.raci.title": "RACI matrix",
    "admin.raci.subtitle": "Who contributes to what, by block typology. This matrix drives automatic email escalations.",
    "admin.raci.team": "Team",
    "admin.raci.matrix": "RACI matrix by typology",
    "admin.raci.th.typology": "Block typology",
    "admin.raci.th.responsible": "Responsible (R)",
    "admin.raci.th.accountable": "Accountable (A)",
    "admin.raci.th.consulted": "Consulted (C)",
    "admin.raci.th.informed": "Informed (I)",
    "admin.detail.notFound": "Item not found",
    "admin.detail.title": (p) => `Administration > ${p.section}`,
    "admin.detail.subtitle": "Editable detail, saved locally.",
    "admin.detail.back": "Back",
    "admin.detail.jsonTitle": "JSON configuration",
    "toast.adminSaved": "Configuration saved",
    "toast.adminInvalidJson": "Invalid JSON",
  },
};
